export default "__VITE_ASSET__DoCvJ4hk__"